import type { JSONSchema7Definition } from "json-schema";

/**
 * Expands a schema property to include its anyOf/oneOf variants for analysis
 */
export const expandPropertyVariants = (
  property: JSONSchema7Definition
): JSONSchema7Definition[] => {
  return typeof property !== "boolean"
    ? [property, ...(property.anyOf || []), ...(property.oneOf || [])]
    : [property];
};

/**
 * Checks if a property (including its variants) has a specific format
 */
export const propertyHasFormat = (property: JSONSchema7Definition, format: string): boolean => {
  const variants = expandPropertyVariants(property);
  return variants.some((variant) => typeof variant !== "boolean" && variant.format === format);
};
